import { render } from "./ActaInspeccionComponent.vue?vue&type=template&id=6973b550"
import script from "./ActaInspeccionComponent.vue?vue&type=script&lang=js"
export * from "./ActaInspeccionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__